import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { X } from 'lucide-react';
export function WhyDidntWork() {
  const reasons = [{
    title: 'Las dietas de 1200 calorías',
    desc: 'solo aumentan tu estrés biológico y bloquean tu metabolismo.'
  }, {
    title: 'El cardio excesivo',
    desc: 'dispara aún más el cortisol, inflamándote más que antes.'
  }, {
    title: 'Los productos "Light"',
    desc: 'están llenos de edulcorantes que destruyen tu flora intestinal y generan gases.'
  }, {
    title: 'Ayunar sin estrategia hormonal',
    desc: 'solo le dice a tu cuerpo que hay "hambruna", obligándolo a reservar grasa abdominal.'
  }, {
    title: 'Los suplementos mágicos',
    desc: 'no sirven si no desactivás primero el interruptor químico de la inflamación.'
  }];
  return <section className="py-20 md:py-32 bg-beige/40" data-id="element-243">
      <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-244">
        <FadeIn data-id="element-245">
          <div className="text-center mb-16" data-id="element-246">
            <span className="inline-block text-gold text-xs font-semibold tracking-[0.2em] uppercase mb-4" data-id="element-247">
              La trampa del fitness tradicional
            </span>
            <h2 className="font-serif text-3xl md:text-4xl text-teal" data-id="element-248">
              Por qué lo que intentaste no funcionó
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-6" data-id="element-249">
          {reasons.map((reason, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-250">
              <div className="flex items-start gap-4 p-6 bg-white/50 rounded-lg border border-teal/5" data-id="element-251">
                <div className="mt-1 flex-shrink-0" data-id="element-252">
                  <X className="text-gold/80" size={20} strokeWidth={1.5} data-id="element-253" />
                </div>
                <div data-id="element-254">
                  <p className="text-teal/90 font-light text-lg" data-id="element-255">
                    <strong className="font-medium" data-id="element-256">{reason.title}</strong>{' '}
                    {reason.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}